import React from "react";
import { useIntl, FormattedMessage } from "react-intl";
import stylesLess from "./index.module.less";

import { Modal } from "antd";

function ModelAlert(props) {
  const {
    isDark = false,
    isConfirm = false,
    title,
    content,
    inner,
    centered = true,
    ...rest
  } = props;
  const className = `${stylesLess.main} ${isDark ? "dark" : "light"}`;

  return Modal[isConfirm ? "confirm" : "info"]({
    title: false,
    icon: false,
    content: (
      <div className={"iBody"}>
        {title && <div className={"iTitle"}>{title}</div>}
        {content && <div className={"iContent"}>{content}</div>}
        {inner && <div className={"iInner"}>{inner}</div>}
      </div>
    ),
    centered,
    className,
    ...rest,
  });
}

ModelAlert.confirm = (props) => ModelAlert({ ...props, isConfirm: true });

export default ModelAlert;
